import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgMoneyPiggybank = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M21.375 9.91666C21.375 10.5797 21.1116 11.2156 20.6428 11.6844C20.1739 12.1533 19.538 12.4167 18.875 12.4167"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.875 8.66665C9.65224 8.28195 10.5078 8.08182 11.375 8.08182C12.2422 8.08182 13.0978 8.28195 13.875 8.66665"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.3125 11.1667C7.25069 11.1667 7.19027 11.185 7.13888 11.2193C7.08749 11.2537 7.04744 11.3025 7.02379 11.3596C7.00014 11.4167 6.99395 11.4795 7.006 11.5401C7.01806 11.6007 7.04783 11.6564 7.09153 11.7001C7.13523 11.7438 7.19092 11.7736 7.25153 11.7857C7.31215 11.7977 7.37499 11.7915 7.43209 11.7679C7.48919 11.7442 7.538 11.7042 7.57233 11.6528C7.60667 11.6014 7.625 11.541 7.625 11.4792C7.625 11.3963 7.59208 11.3168 7.53347 11.2582C7.47487 11.1996 7.39538 11.1667 7.3125 11.1667Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.58333 6.06916C7.605 4.29666 5.125 4.29166 5.125 4.29166L5.64667 7.94499C4.96452 8.68837 4.45866 9.57591 4.16667 10.5417H2.625V15.5417H4.7C5.13154 16.2983 5.69944 16.9685 6.375 17.5183V19.9167C6.375 20.0824 6.44085 20.2414 6.55806 20.3586C6.67527 20.4758 6.83424 20.5417 7 20.5417H8.25C8.41576 20.5417 8.57473 20.4758 8.69194 20.3586C8.80915 20.2414 8.875 20.0824 8.875 19.9167V18.8825C10.497 19.4249 12.251 19.4281 13.875 18.8917V19.9167C13.875 20.0824 13.9408 20.2414 14.0581 20.3586C14.1753 20.4758 14.3342 20.5417 14.5 20.5417H15.75C15.9158 20.5417 16.0747 20.4758 16.1919 20.3586C16.3092 20.2414 16.375 20.0824 16.375 19.9167V17.5308C17.146 16.9181 17.7705 16.141 18.203 15.2563C18.6355 14.3715 18.8651 13.4014 18.875 12.4167C18.875 7.00499 13 4.59249 8.58333 6.06916Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgMoneyPiggybank.displayName = 'SvgMoneyPiggybank';
export default SvgMoneyPiggybank;
